import { useQuery } from "react-query";
import getAuditData, { AuditDataResponse } from "../services/getAuditData";
import {
  MRT_ColumnFiltersState,
  MRT_PaginationState,
  MRT_SortingState,
} from "mantine-react-table";
function useGetAuditData(
  token: string,
  pagination: MRT_PaginationState,
  columnFilters: MRT_ColumnFiltersState,
  sorting: MRT_SortingState
) {
  return useQuery<AuditDataResponse>({
    queryKey: ["get-audit-data", pagination, columnFilters, sorting],
    queryFn: () => getAuditData({ token, pagination, columnFilters, sorting }),
    retry: false,
    keepPreviousData: true,
    staleTime: 30_000,
  });
}

export default useGetAuditData;
